import styled from '@emotion/styled'
import React from 'react';

const ButtonScaleWrapper = styled.div`
    position: relative;
    nav {
        display: flex;
        justify-content: center;
        button {
            padding: 12.5px;
            border-radius: 50%;
            aspect-ratio: 1/1;
            background-color: var(--color-gray-blue-100);
            box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75), 2px 2px 5px 0px rgba(0, 0, 0, 0.05);
            &:hover {
                box-shadow: -2px -2px 10px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 10px 0px rgba(0, 0, 0, 0.05) inset;
            }
            position: absolute;
            top: 0;
            right: 0;
        }
    }
    div {
        img {
            display: block;
            width: 96px;
            image-rendering: pixelated;
            margin: 0 auto;
        }
        &.scale {
            img {
                width: 192px;
            }
        }
    }

`

const ButtonScale = ({children, scale, setScale}) => {
    return(
        <ButtonScaleWrapper>
            <nav>
                <button onClick={()=>{setScale(!scale)}}>
                    {
                        scale?
                        <img src="/image/icon/icon_scale_down_gray.svg" alt="축소"/>
                        :<img src="/image/icon/icon_scale_up_gray.svg" alt="확대"/>
                    }
                </button>
            </nav>
            <div className={scale?"scale":""}>
                {children}
            </div>
            
            
        </ButtonScaleWrapper>
    )
}

export default ButtonScale;